import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  Card,
  Row,
  Col,
  DatePicker,
  Checkbox,
  Divider,
  Space,
  Steps,
  Affix,
  Modal,
  Upload,
  Typography,
  UploadProps,
  message,
  Descriptions,
} from 'antd';
import { MinusCircleOutlined, PlusCircleOutlined } from '@ant-design/icons';
import {
  DepartmentDto,
  EmployeeDeptRequest,
  EmployeeDto,
  HrmsEmployeeDetailsDto,
  PlantsDropDown,
} from '@gtpl/shared-models/masters';
import { IndiaStatesEnum, LeaveApprovalStatusEnum } from '@gtpl/shared-models/common-models';
import TextArea from 'antd/lib/input/TextArea';
import { RequestFormDto } from '../../../../../../shared-models/vms/src/lib/request-form/request.dto';
import { RequestService } from '../../../../../../shared-services/vms/src/lib/request.service';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { DepartmentService } from '../../../../../.././shared-services/masters/src/lib/department-service';
import { Link, useHistory } from 'react-router-dom';
import { EmployeeService } from '../../../../../.././shared-services/masters/src/lib/employee-details.service';
import { request } from 'http';
import VisitorDetailedView from './visitor-detailed-view';
import moment from 'moment';
import { RequestById } from 'libs/shared-models/vms/src/lib/request-form/request.request';
// import type { RangePickerProps } from 'antd/es/date-picker';

const { Option } = Select;
const layout = {
  labelCol: {
    span: 10,
  },
  wrapperCol: {
    span: 8,
  },
};

export interface RequestFormProps {
  // requestData: any;
  // updateDetails: (request: any) => void;
  // isUpdate: boolean;
  // closeForm: () => void;
}

export function RequestForm(props: RequestFormProps) {
  const [form] = Form.useForm();
  const [departmentsData, setDepartmentsData] = useState<DepartmentDto[]>([]);
  const departmentService = new DepartmentService();
  const [employeeData, setEmployeeData] = useState<EmployeeDto[]>([]);
  const employeeService = new EmployeeService();
  const [transportationData, setTransportationData] = useState<boolean>(false);
  const [visitorVisible, setVisitorVisible] = useState<boolean>(true);
  const [plantUserVisible, setPlantUserVisible] = useState<boolean>(false);
  const service = new RequestService();
  const [dynamic, setDynamic] = useState({ visitorName: [' '] });
  let history = useHistory();
  const [deptId, setDeptId] = useState<DepartmentDto>();
  const [empData, setEmpData] = useState<EmployeeDto[]>([]);
  const [showpopup, setShowpopup] = useState<boolean>(false);
  const [requestData, setRequestData] = useState<RequestFormDto[]>([]);
  const [open, setOpen] = useState<boolean>(false);
  const [previewdata, setPreviewData] = useState<RequestFormDto>(null);
  const [departDate,setDepartDate] = useState<any>();

  useEffect(() => {
    getAllActiveDepartment();
    onArrivalChange();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      visitorDepartureDate: departDate
    });
  }, [departDate]);

  const walkinApprovedData = (res) => {
    if(res.visitType == 'Walk-in') {
            const req = new RequestFormDto(res.requestId,res.visitType,res.employeeName,res.employeeCode,res.department,res.visitorName,res.visitorCard,res.visitorEmail,res.visitorMobileNumber,res.aadharNumber,res.visitorAddress,res.visitorArrivalDate,res.visitorDepartureDate,res.purposeOfVisit,res.whomMeet,res.transportation,res.vehicleNumber,res.driverName,LeaveApprovalStatusEnum.APPROVED,res.statusByHr,res.rejectionReason,res.createdUser,true,res.updatedUser,res.versionFlag) 
            service.updateStatusHod(req)
          }
  }

  const getAllActiveDepartment = () => {
    departmentService
      .getAllActiveDepartment()
      .then((res) => {
        if (res.status) {
          setDepartmentsData(res.data);
          console.log(res.data, 'departmentsdata');
        } else {
          if (res.intlCode) {
            setDepartmentsData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      })
      .catch((err) => {
        setDepartmentsData([]);
        AlertMessages.getErrorMessage(err.message);
      });
  };

  const getEmployeeData = () => {
    const department = form.getFieldValue('department');
    console.log(department,"dddd")
    const req= new EmployeeDeptRequest(department);
    console.log(req,"rrrr")
    employeeService.getActiveEmployeesByDept(req)
      .then((res) => {
        if (res.status) {
          setEmployeeData(res.data);
          console.log(res.data, 'employeedata');
        } else {
          if (res.intlCode) {
            setEmployeeData([]);
            AlertMessages.getErrorMessage(res.internalMessage);
          } else {
            console.log('error');
            AlertMessages.getErrorMessage(res.internalMessage);
          }
        }
      })
      .catch((err) => {
        setEmployeeData([]);
        AlertMessages.getErrorMessage(err.message);
      });
  };

  function onChange(value) {
    console.log(`selected ${value}`);
    departmentsData.map((e) => {
      if (e.deptId === value) {
        console.log(e.deptName, 'depart');
      }
    });
    setDeptId(value);
    getEmployeeData();
  }

  function onSearch(val) {
    console.log('search:', val);
  }

  let createdUser = '';
  createdUser = localStorage.getItem('createdUser');

  const saveData = (values) => {
    if (values.visitorMobileNumber.length < 12) {
      AlertMessages.getErrorMessage('Please provide 91 before mobile number');
    } else {
    setRequestData(values);
    setShowpopup(true);
    }
  };

  const onReset = () => {
    form.resetFields();
  };

  const handleOk = () => {
    setOpen(false);
    //history.push({pathname:'#/detailed-view',state:{id: id}})
  };

  const formType = (value) => {
    // setTransferType(value);
    if (value === 'Vendor Form') {
      setVisitorVisible(true);
    } else {
      setVisitorVisible(false);
    }
    if (value === 'Plant-user Form') {
      setPlantUserVisible(true);
    } else {
      setPlantUserVisible(false);
    }
  };

  const transportationDisplay = (value) => {
    if (value == 'With Vehicle') {
      setTransportationData(true);
    } else {
      setTransportationData(false);
    }
  };

  const prefix = (
    <Form.Item name="prefix" noStyle label="Please Select">
      <Select style={{ width: 100 }} placeholder="Id" defaultValue={'aadhaar'}>
        <Option value="aadhaar">Aadhaar </Option>
        <Option value="pan">PAN</Option>
        <Option value="voter">Voter Id</Option>
        <Option value="passport">Passport</Option>
      </Select>
    </Form.Item>
  );

  const saveRequest = (requestData: any) => {
      requestData.visitorName = requestData.visitorName.map((e) => {
        return e.first;
      });
      console.log('submit clicked');
      service.createRequest(requestData).then((res) => {
          if (res.status) {
            AlertMessages.getSuccessMessage(
              'Request Details Created Successfully'
            );
            console.log(res.data);
            setPreviewData(res.data);
            walkinApprovedData(res.data);
            //  history.push({pathname:'#/detailed-view',state:{id:res.data.requestId}})
            onReset();
          } else {
            if (res.intlCode) {
              AlertMessages.getErrorMessage(res.internalMessage);
            } else {
              AlertMessages.getErrorMessage(res.internalMessage);
            }
          }
        }).catch((err) => {
          AlertMessages.getErrorMessage(err.message);
        });
  };

  const handlesubmit = () => {
    setShowpopup(false);
    saveRequest(requestData);
    setOpen(true);
  };

  const disabledDate = (current) => {
   // console.log(current.valueOf(), 'current');
    return current.valueOf() < Date.now();
  };

  const outDatePicker = () => {
    const arrivalDate = form.getFieldValue('visitorArrivalDate');
    console.log(arrivalDate, 'arrival');
    const departureDate = form.getFieldValue('visitorDepartureDate');
    const diff = (departureDate - arrivalDate) / 864e5;
    if (diff > 4) {
      AlertMessages.getErrorMessage('Visit more than 3 days is not allowed');
    }
  };

  const onArrivalChange = () => {
    const date = form.getFieldValue('visitorArrivalDate');
    // console.log(date.getMonth(),'month')
    // console.log(date.getDate(),'date')
    // console.log(date.getYear(),'year')
    const deparDate = new Date(date);
    console.log(deparDate,"===================")
    deparDate.setDate(deparDate.getDate()+3)
    console.log(deparDate,"*************")
    const departChange = moment(moment(deparDate).format('YYYY-MM-DD HH:mm:ss'))
    console.log(departChange,"--------------------")
    setDepartDate(departChange)
     console.log(departDate,"&&&&&&&&&&")
    //  console.log(moment(moment().format("YYYY-MM-DD HH:mm:ss")),"*************")
    //  console.log(departDate.format('YYYY-MM-DD HH:mm:ss'),"----------")


  }

  return (
    <Card
      title={<span style={{ color: 'white' }}>Request Form</span>}
      style={{ textAlign: 'center' }}
      headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
    >
      <Form
        form={form}
        initialValues={dynamic}
        onFinish={saveData}
        name="control-hooks"
        layout="vertical"
      >
        <br />
            <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5, offset: 1 }} lg={{ span: 5, offset: 1 }} xl={{ span: 5, offset: 1 }} style={{ margin: '1%' }} >
              <Form.Item
                name="visitType"
                label="Visit Type"
                initialValue={'Vendor Form'}
                rules={[
                  {
                    required: true,

                  }
                ]}>
                {<Select
                  onChange={formType}
                  showSearch
                  placeholder="Select Visit Type"
                  defaultValue={'Vendor Form'}
                >

                  <Option key={1} value={'Vendor Form'}>Vendor</Option>
                  {/* <Option key={2} value={'Plant-user Form'}>Plant User</Option> */}
                  <Option key={2} value={'Walk-in'}>Walk-In</Option>
                </Select>}
              </Form.Item>
            </Col>
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.List name="visitorName">
                  {(fields, { add, remove }) => (
                    
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Space
                          key={key}
                          style={{ display: 'flex', marginTop: '5%' }}
                        >
                          <Form.Item
                            {...restField}
                            name={[name, 'first']}
                            label={name>0 ? "Visitor Name"+ - +name : "Visitor Name"}
                            rules={[
                              { 
                                required: true ,
                                message: 'visitor name required',
                                
                              },
                              {
                                max: 32,
                                message:`visitor name cannot be greater than 32`
                              },
                              { 
                                pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                                message: `Should contain only alphabets.`,
                              }
                            ]}
                          >
                            <Input
                              placeholder="Enter Visitor Name"
                              width={130}
                            />
                          </Form.Item>

                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Space>
                      ))}
                      <Form.Item>
                        <Button
                          type="primary"
                          onClick={() => add()}
                          style={{ marginTop: '5%', marginRight: '100%' }}
                        >
                          Add
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </Row>
            <Row gutter={24}>
              <Form.Item name="requestId" style={{ display: 'none' }}>
                <Input hidden />
              </Form.Item>
              <Form.Item
                style={{ display: 'none' }}
                name="createdUser"
                initialValue={createdUser}
              >
                <Input hidden />
              </Form.Item>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="visitorEmail"
                  label="Email Id"
                  rules={[
                    {
                      required: false,
                      type: 'email',
                      message: 'Please enter your email Id',
                      max: 25,
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="visitorMobileNumber"
                  label="Mobile Number"
                  rules={[
                    {
                      required: true,
                      message: 'Mobile Number is not valid',
                      min: 10,
                      max: 12,
                    },
                    {
                      pattern: /^[0-9]*$/,
                      message: `Letters , Spaces and Special charecters are not aloowed`,
                    },
                  ]}
                >
                  <Input defaultValue={91} />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="department"
                  label="Department"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Department',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select Department"
                    optionFilterProp="children"
                    onChange={onChange}
                    onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {departmentsData?.map((dropData) => {
                      return (
                        <Option
                          key={dropData.deptName}
                          value={dropData.deptName}
                        >
                          {dropData.deptName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="aadharNumber"
                  label="Id Number"
                  rules={[
                    {
                      required: true,
                      message: 'Id Number Required',
                    },
                  ]}
                >
                  <Input addonBefore={prefix} placeholder="Enter Id Number" />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="visitorArrivalDate"
                  label="Check-In Date"
                  initialValue={moment(moment().format("YYYY-MM-DD HH:mm:ss"))}
                  rules={[
                    {
                      required: true,
                      message: 'Please select a valid date',
                    },
                  ]}
                >
                  <DatePicker
                    disabledDate={disabledDate}
                    style={{ width: '100%' }}
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    showToday={false}
                    defaultValue={moment(moment().format("YYYY-MM-DD HH:mm:ss"))}
                    onChange={onArrivalChange}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="visitorDepartureDate"
                  label="Check-Out Date"
                  initialValue={departDate}
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: 'Please select a valid date',
                  //   },
                  // ]}
                >
                  <DatePicker
                    onChange={outDatePicker}
                    disabledDate={disabledDate}
                    style={{ width: '100%' }}
                    showTime
                    format="YYYY-MM-DD HH:mm:ss"
                    showToday={false}
                    defaultValue={departDate}
                  />
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="whomMeet"
                  label="Whom To Meet"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Name',
                    },
                  ]}
                >
                  <Select
                    showSearch
                    placeholder="Select whom to meet"
                    optionFilterProp="children"
                    // onSearch={onSearch}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {employeeData?.map((dropData) => {
                      return (
                        <Option
                          key={dropData.employeeName}
                          value={dropData.employeeName}
                        >
                          {dropData.employeeName}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="purposeOfVisit"
                  label="Purpose Of Visit"
                  rules={[
                    {
                      required: true,
                      message: 'Enter Purpose Of visit',
                    },
                    {
                      max: 30,
                    },
                    {
                      pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                      message: `Should contain only alphabets.`,
                    },
                  ]}
                >
                  <Input placeholder="Purpose Of Visit" max={30}/>
                </Form.Item>
              </Col>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 5, offset: 1 }}
                lg={{ span: 5, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="transportation"
                  label="Mode Of Transport"
                  rules={[]}
                >
                  {
                    <Select
                      showSearch
                      placeholder="Select Mode Of Transport"
                      onChange={transportationDisplay}
                    >
                      <Option key={1} value={'Without Vehicle'}>
                        Without Vehicle
                      </Option>
                      <Option key={2} value={'With Vehicle'}>
                        With Vehicle
                      </Option>
                    </Select>
                  }
                </Form.Item>
              </Col>

              {transportationData ? (
                <>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 5, offset: 1 }}
                    lg={{ span: 5, offset: 1 }}
                    xl={{ span: 5, offset: 1 }}
                    style={{ margin: '1%' }}
                  >
                    <Form.Item 
                      name="vehicleNumber" 
                      label="Vehicle Number"
                      rules={[{
                        max:15,
                      },
                        {
                        pattern: /^[^-\s\\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z0-9. ]*$/,
                        message: "Vehicle Number shouldn't contain special charecters",
                      }]}
                    >
                      <Input placeholder="Enter Vehicle Number"  max={15}/>
                    </Form.Item>
                  </Col>
                  <Col
                    xs={{ span: 24 }}
                    sm={{ span: 24 }}
                    md={{ span: 5, offset: 1 }}
                    lg={{ span: 5, offset: 1 }}
                    xl={{ span: 5, offset: 1 }}
                    style={{ margin: '1%' }}
                  >
                    <Form.Item
                      name="driverName"
                      label="Driver's Name"
                      rules={[
                        {
                          max:32,
                        },
                        {
                          pattern: /^[^-\s\\0-9\[\]()*!@#$^&_\-+/%=`~{}:";'<>,.?|][a-zA-Z. ]*$/,
                          message: `Should contain only alphabets.`,
                          
                        },
                      ]}
                    >
                      <Input placeholder="Enter Name" max={36} />
                    </Form.Item>
                  </Col>
                </>
              ) : (
                <></>
              )}
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 10, offset: 1 }}
                lg={{ span: 10, offset: 1 }}
                xl={{ span: 5, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item name="vaccination" label="Covid Vaccination" initialValue={'notApplicable'}>
                  <Select
                    showSearch
                    allowClear={true}
                    defaultValue={'notApplicable'}
                    
                  >
                    <Option key={1} value={'notApplicable'}>
                      {' '}
                      Not Applicable
                    </Option>
                    <Option key={2} value={'1stdose '}>
                      1st Dose
                    </Option>
                    <Option key={3} value={'2nddose '}>
                      2nd Dose
                    </Option>
                    <Option key={4} value={'booster'}>
                      Booster{' '}
                    </Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col
                xs={{ span: 24 }}
                sm={{ span: 24 }}
                md={{ span: 10, offset: 1 }}
                lg={{ span: 10, offset: 1 }}
                xl={{ span: 10, offset: 1 }}
                style={{ margin: '1%' }}
              >
                <Form.Item
                  name="visitorAddress"
                  label="Visitor's Address"
                  rules={[
                    {
                      required: true,
                      //   pattern: /^[^-\s][a-zA-Z0-9_\s-]*$/,
                      //   // message: `Don't Allow Spaces`
                      max: 50,
                      min:10,
                    },
                  ]}
                >
                  <TextArea rows={4} style={{ width: '100%' }} minLength={10}/>
                  {/* <TextArea size='large' aria-multiline /> */}
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24} style={{ textAlign: 'right' }}>
                {/* <Link to='/detailed-view' ><span style={{ color: 'white' }} > */}
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
                {/* </span>
                </Link> */}
                {true && (
                  <Button
                    htmlType="button"
                    style={{ margin: '0 14px' }}
                    onClick={onReset}
                  >
                    Reset
                  </Button>
                )}
              </Col>
            </Row>  
      </Form>
      <Modal
        className="qr-container"
        key={'modal' + Date.now()}
        width={'95%'}
        style={{ top: 30, alignContent: 'right' }}
        visible={showpopup}
        footer={[
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => handlesubmit()}
          >
            Submit
          </Button>,
          <Button
            key="back"
            onClick={() => {
              setShowpopup(false);
            }}
          >
            Cancel
          </Button>,
        ]}
        title={<React.Fragment></React.Fragment>}
      >
        <Form>
          <p>
            Keep physical distance of at least 1 metre from others, even if they
            don’t appear to be sick. Avoid crowds and close contact.
          </p>
          <p>Wear a mask properly</p>
          <p>Regularly and thoroughly clean your hands</p>
          <Form.Item
            name="agree"
            valuePropName="checked"
            rules={[
              {
                required: true,
                message: 'To proceed you need to agree',
              },
              // {
              //   validator: (_, value) =>
              //     value
              //       ? Promise.resolve()
              //       : Promise.reject("To proceed you need to agree"),
              // },
            ]}
          >
            <Checkbox>Accept terms and conditions</Checkbox>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        width={'95%'}
        centered
        visible={open}
        footer={[
          <Button type="primary" htmlType="submit" onClick={() => handleOk()}>
            Ok
          </Button>,
        ]}
      >
        <p><b><mark>
          Succesfully Registered.</mark></b><h3> We will sent VisitorPass after your request is
          accepted.
          </h3> </p>
        <Card
          title={<span style={{ color: 'white' }}>Visitor Detailed View</span>}
          style={{ textAlign: 'center' }}
          headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        >
          <Descriptions>
            <Descriptions.Item label="Requisition Code">
              {' '}
              {previewdata?.requestId}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Visitor Name">
              {' '}
              {`${previewdata?.visitorName.slice(
                0,
                previewdata.visitorName.length
              )}`}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Visitor Email">
              {' '}
              {previewdata?.visitorEmail}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Mobile Number">
              {' '}
              {previewdata?.visitorMobileNumber}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Check-In Date">
              {' '}
              {moment(previewdata?.visitorArrivalDate).format(
                'YYYY-MM-DD HH:mm:ss'
              )}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Check-Out Date">
              {' '}
              {moment(previewdata?.visitorDepartureDate).format(
                'YYYY-MM-DD HH:mm:ss'
              )}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Whom to Meet">
              {' '}
              {previewdata?.whomMeet}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Department">
              {' '}
              {previewdata?.department}{' '}
            </Descriptions.Item>
            <Descriptions.Item label="Purpose Of Visit">
              {' '}
              {previewdata?.purposeOfVisit}{' '}
            </Descriptions.Item>
          </Descriptions>
        </Card>
      </Modal>
    </Card>
  );
}

export default RequestForm;
